var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.423728,22.372881)",
    id: "g3831"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -70.170631,-9.51428 c -3.832506,2.8635107 -3.832506,7.4740727 0,10.33758464 L -56.334872,11.160885 c 3.832505,2.86351 10.003253,2.86351 13.835759,0 L -28.663354,0.82330464 c 3.832506,-2.86351194 3.832506,-7.47407394 0,-10.33758464 l -3.026571,-2.261346 -10.114473,7.5571695 3.891307,2.9074461 -18.710026,2.3496805 3.144798,-13.9794631 3.891308,2.907447 10.114471,-7.557171 -3.026573,-2.261347 c -3.832506,-2.86351 -10.003254,-2.86351 -13.835759,0 z",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -71.6692,3.6090768 c -2.23069,2.8058276 -1.738451,6.4665372 1.498395,8.8849932 l 13.835876,10.337668 c 3.832505,2.86351 10.003367,2.86351 13.835873,0 L -28.663182,12.49407 c 3.236848,-2.418456 3.729086,-6.0791656 1.498394,-8.8849932 -0.4105,0.5163398 -0.902736,1.0064314 -1.498394,1.451485 L -42.499056,15.398231 c -3.832506,2.86351 -10.003368,2.86351 -13.835873,0 L -70.170805,5.0605618 C -70.766462,4.6155082 -71.258699,4.1254166 -71.6692,3.6090768 Z",
    id: "svg_1-5-4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlm);
export default __webpack_public_path__ + "static/media/plm.c7d5dfe60d89e7a47f30e30e896cef04.svg";
export { ForwardRef as ReactComponent };